<template>
  <div id="car2">
    <div class="car-box">
      <div class="car-title">我的购物车</div>
      <div v-if="shopList.length > 0">
        <div
          class="car-item-box"
          v-for="(item,index) in shopList"
          :key="index"
          :class="index > 0?'margin-t':''"
        >
          <div class="item-title">
            <el-checkbox
              size="medium"
              @change="checkItemAll($event,index,item.tableList)"
              v-model="titleCheck[index]"
              :label="item.company"
            ></el-checkbox>
          </div>
          <div class="table-box">
            <el-table
              :data="item.tableList"
              style="width: 100%"
              :header-cell-style="{'background-color':'#EAEDF1'}"
            >
              <el-table-column width="90">
                <template slot-scope="scope">
                  <el-checkbox
                    style="text-align:center;line-height:60px;width:60px;height:60px"
                    @change="checkProdcut($event,index,item.tableList,scope.$index)"
                    v-model="scope.row.checked"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" width="500">
                <template slot-scope="scope">
                  <router-link :to="'/product/' + scope.row.p_id">
                    <div class="image-product">
                      <div class="image-box">
                        <img :src="serve + scope.row.images" alt />
                      </div>
                      <div class="title-box">
                        <div class="product-title">{{scope.row.title}}</div>
                        <div class="item_no">货号:{{scope.row.item_no}}</div>
                      </div>
                    </div>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column label="单价">
                <template slot-scope="scope">
                  <div class="price">￥{{scope.row.selling_price}}</div>
                  <div
                    v-if="parseInt(scope.row.number) > parseInt(scope.row.inventory)"
                    style="font-size:13px;color:#e2211c"
                  >库存不足，可预购！</div>
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                  <div class="number">
                    <el-input-number
                      size="mini"
                      v-model="scope.row.number"
                      @change="numberChange($event,scope.row.car_id)"
                      :min="1"
                      label="描述文字"
                    ></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="小计">
                <template slot-scope="scope">
                  <div
                    class="total"
                  >￥{{Math.round((scope.row.selling_price * scope.row.number)*100)/100}}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="do">
                    <div
                      @click="delFav(scope.row.p_id)"
                      class="action"
                      v-if="scope.row.isCollect"
                    >取消收藏</div>
                    <div
                      @click="addFav(scope.row.p_id)"
                      class="action"
                      v-if="!scope.row.isCollect"
                    >加入收藏夹</div>
                    <div @click="delItem(scope.row.car_id)" class="action">删除</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="foot-box">
          <div class="font-w clearfix">
            <div style="max-width:1020px;float:left">
              <el-checkbox
                v-model="checkAllSign"
                @change="checkAll($event)"
                style="margin-left:24px;"
                label="全选"
              ></el-checkbox>
              <span class="join-collect" style="margin-left:25px">移入收藏夹</span>
              <span @click="delchecks" class="del-check" style="margin-left:26px">删除选择商品</span>
              <span style="margin-left:30px">共</span>
              <span class="red">&nbsp;{{productNumber}}&nbsp;</span>
              <span>件商品，已选择</span>
              <span class="red">&nbsp;{{checkNumber}}&nbsp;</span>
              <span>件</span>
              <span class="font-h" style="margin-left:14px">|</span>
              <span
                class="font-h"
                style="margin-left:11px"
              >商品合计:￥{{totalMoney}} &nbsp;&nbsp;活动优惠:-￥0.00</span>
              <span class="font-h" style="margin-left:12px">|</span>
              <span style="margin-left:12px">应付总金额&nbsp;:&nbsp;</span>
              <span class="font-all-money">￥{{totalMoney}}</span>
            </div>
            <!-- <div class="create-order" v-if="is_shop" @click="centerDialogVisible = true">结算</div> -->

            <el-popover placement="top-end" width="160" :disabled="is_visible" v-model="visible">
              <p style="font-size:14px;text-align:center;color:#e2211c">温馨提示</p>
              <p style="font-size:13px">预购商品和现货商品不能加入同一个订单，请重新选择！</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <!-- <el-button type="primary" size="mini" @click="visible = false">确定</el-button> -->
              </div>
              <div class="create-order" slot="reference" @click="submit(1)">结算</div>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        <div class="icon-box">
          <i class="big-car iconfont icon-icon-test-copy-copy-copy"></i>
        </div>
        <div class="empty-title">购物车内暂时没有商品</div>
        <router-link to="/">
          <div class="to-index">去首页</div>
        </router-link>
      </div>
      <div class="guess-like">
        <div class="guess-title">
          <span class="guess-title-font">猜你喜欢</span>
        </div>
        <div class="guess-data clearfix">
          <div
            class="data-item"
            :class="index > 3 ?'clear-m':''"
            v-for="(item,index) in guessData"
            :key="index"
          >
            <router-link :to="'/product/' + item.id">
              <div class="img-box">
                <img :src="serve + item.images" alt />
              </div>
            </router-link>
            <router-link :to="'/product/' + item.id">
              <div class="title">{{item.title}}</div>
            </router-link>
            <div class="price">￥{{item.selling_price}}</div>
            <div class="join-car">
              <el-button @click="joinCar(item.id)" size="mini">加入购物车</el-button>
            </div>
          </div>
        </div>
      </div>
      <div style="height:50px"></div>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="25%" center>
      <div
        style="padding:20px 0;line-height:26px "
      >注意 : 实际付款金额不包含店铺商品，只包含自营商品，店铺商品还需商家与您进行下一步操作。实际付款金额请以下单页为准。</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          style="width:140px"
          @click="centerDialogVisible = false,submit(2)"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      is_visible: true,
      visible: false,
      is_shop: false,
      centerDialogVisible: false,
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      multipleSelection: [],
      total: 0,
      shopList: [],
      productNumber: 0,
      checkNumber: 0,
      totalMoney: 0,
      checkArr: [],
      titleCheck: [],
      itemProduct: [],
      checkAllSign: true,
      guessData: []
    };
  },
  activated() {
    this.loadDate();
  },
  created() {
    this.guessLike();
  },
  methods: {
    alertMessage(messsage, type) {
      this.$message({
        message: messsage,
        type: type,
        offset: 200
      });
    },
    delchecks() {
      var idS = "";
      for (var i in this.shopList) {
        var tableList = this.shopList.tableList;
        for (var k in tableList) {
          if (tableList[k].checked) {
            idS += tableList[k].car_id + ",";
          }
        }
      }
      this.delItem(idS);
    },
    submit(join) {
      var shopList = this.shopList;
      var formData = [];
      var check = [];
      var key = 0;
      var fa = false;
      var tr = false;
      for (var i in shopList) {
        var tableList = shopList[i].tableList;
        for (var n in tableList) {
          if (tableList[n].checked) {
            formData[key] = tableList[n].car_id;
            check[key] = tableList[n].p_id;
            key++;
            if (tableList[n].inventory_type) {
              fa = true;
            } else {
              tr = true;
            }
          }
        }
      }
      if (fa && tr) {
        this.is_visible = false;
        return;
      }
      this.is_visible = true;
      if (formData.length == 0) {
        this.alertMessage("请选择要结算的商品", "error");
        return;
      }
      this.$router.push({
        path: "/user/order4",
        query: { car_ids: JSON.stringify(formData) }
      });
    },
    computerMoney(shopList) {
      var totalMoney = 0;
      for (var i in shopList) {
        var tableList = shopList[i].tableList;
        for (var k in tableList) {
          if (tableList[k].checked) {
            var money =
              Math.round(
                tableList[k].selling_price * tableList[k].number * 100
              ) / 100;
            totalMoney += parseFloat(money);
          }
        }
      }
      this.totalMoney = Math.round(totalMoney * 100) / 100;
    },
    computerNumber(shopList) {
      var number = 0;
      var checkNumber = 0;
      for (var i in shopList) {
        var tableList = shopList[i].tableList;
        for (var k in tableList) {
          number += parseFloat(tableList[k].number);
          if (tableList[k].checked) {
            checkNumber += parseFloat(tableList[k].number);
          }
        }
      }
      this.productNumber = number;
      this.checkNumber = checkNumber;
    },
    checkItem(shopList) {
      var bool = true;
      for (var i in shopList) {
        var tableList = shopList[i].tableList;
        var checked = true;
        for (var k in tableList) {
          if (!tableList[k].checked) {
            checked = false;
          }
        }
        this.titleCheck[i] = checked;
        if (!this.titleCheck[i]) {
          bool = false;
        }
      }
      if (bool) {
        this.checkAllSign = true;
      } else {
        this.checkAllSign = false;
      }
    },
    checkAll(event) {
      if (event) {
        for (let i in this.shopList) {
          this.titleCheck[i] = true;
          var tableList = this.shopList[i].tableList;
          for (let k in tableList) {
            tableList[k].checked = true;
          }
          this.shopList[i].tableList = tableList;
          this.checkArr[i] = tableList.length;
        }
      } else {
        for (let i in this.shopList) {
          this.titleCheck[i] = false;
          var tableList = this.shopList[i].tableList;
          for (let k in tableList) {
            tableList[k].checked = false;
          }
          this.shopList[i].tableList = tableList;
          this.checkArr[i] = 0;
        }
      }
      this.computerNumber(this.shopList);
      this.computerMoney(this.shopList);
    },
    checkItemAll(event, index, tableList) {
      for (var k in tableList) {
        // if(tableList[k].checked === false){
        //   this.is_shop = false
        // }
      }
      var item = [];
      for (var m = 0; m < tableList.length; m++) {
        if (event) {
          tableList[m].checked = true;
        } else {
          tableList[m].checked = false;
        }
      }
      this.shopList[index].tableList = tableList;
      this.computerNumber(this.shopList);
      this.computerMoney(this.shopList);
      this.checkItem(this.shopList);
      this.$forceUpdate();
    },
    checkProdcut(event, index, tableList, $index) {
      var number = this.checkArr[index];
      if (isNaN(number)) {
        number = tableList.length;
      }
      var tableItem = tableList[$index];
      if (event) {
        this.checkNumber++;
        number++;
      } else {
        this.checkNumber--;
        number--;
      }
      this.checkArr[index] = number;
      this.checkItem(this.shopList);
      this.computerNumber(this.shopList);
      this.computerMoney(this.shopList);
      this.$forceUpdate();
    },
    numberChange(v, id) {
      var that = this;
      this.axios
        .get(this.serve + "/member/change_car_number", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id,
            number: v
          }
        })
        .then(res => {
          this.loadDate();
          this.computerNumber(this.shopList);
          this.computerMoney(this.shopList);
        });
    },
    loadDate() {
      var that = this;
      this.axios
        .get(this.serve + "/member/car_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data && res.data.total > 0) {
            var totalMoney = 0;
            var tableList = res.data.resultsList;
            var shopList = res.data.shopList;
            this.is_shop = false;
            for (let i in shopList) {
              if (shopList[i].id != 0) {
                this.is_shop = true;
              }
              var arr = [];
              for (let k in tableList[shopList[i].id]) {
                tableList[shopList[i].id][k].checked = true;
                //加入库存值
                if (
                  parseInt(tableList[shopList[i].id][k].inventory) >=
                  parseInt(tableList[shopList[i].id][k].number)
                ) {
                  tableList[shopList[i].id][k].inventory_type = true;
                } else if (
                  parseInt(tableList[shopList[i].id][k].inventory) <
                  parseInt(tableList[shopList[i].id][k].number)
                ) {
                  tableList[shopList[i].id][k].inventory_type = false;
                }
                //
                arr.push(tableList[shopList[i].id][k]);
              }
              this.titleCheck[i] = true;
              shopList[i].tableList = arr;
            }
            this.computerNumber(shopList);
            this.computerMoney(shopList);
            // for(var key in shopList.tableList){
            //   if(shopList.tableList[key].inventory  < shopList.tableList[key].number){
            //     type_list = true
            //   }else{
            //     shopList.tableList[key].type = false
            //   }
            // }
            this.shopList = shopList;
            this.checkAllSign = true;
          } else {
            that.shopList = [];
          }
        });
    },
    delFav(id) {
      this.axios
        .get(this.serve + "/member/cancel_collect", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.alertMessage("已取消收藏", "info");
            this.loadDate();
          }
        });
    },
    addFav(id) {
      this.axios
        .get(this.serve + "/member/add_collect", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.alertMessage("收藏了选中的商品", "success");
            this.loadDate();
          }
        });
    },
    delItem(id) {
      var that = this;
      this.axios
        .get(this.serve + "/member/del_car", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          this.alertMessage("商品已经从购物车中移除", "warning");
          that.loadDate();
        });
    },
    guessLike() {
      var formData = {
        mobile: this.mobile,
        token: this.token,
        limit: 5
      };
      this.axios
        .get(this.serve + "/member/guess_like", { params: formData })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.guessData = data.data;
          } else {
            this.guessData = [];
          }
        });
    },
    joinCar(id) {
      var where = {
        mobile: this.mobile,
        token: this.token,
        id: id,
        number: 1
      };
      this.axios
        .get(this.serve + "/member/add_car", {
          params: where
        })
        .then(res => {
          if (res.data.status == "success") {
            this.alertMessage("商品已加入购物车", "success");
          } else {
            this.alertMessage(res.data.msg, "error");
          }
          this.loadDate();
        });
    }
  }
};
</script>
<style lang='scss'>
#car2 {
  .clearfix:after  {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  width: 100%;
  border-top: 2px solid #e2211c;
  .font-w {
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .font-h {
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
  .font-all-money {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(226, 33, 28, 1);
  }
  .create-order {
    width: 176px;
    height: 60px;
    background: rgba(226, 33, 28, 1);
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(254, 254, 254, 1);
    text-align: center;
    float: right;
    cursor: pointer;
  }
  .red {
    color: #e2211c;
  }
  .action {
    font-size: 12px;
    color: #333;
  }
  .action:hover {
    color: #e2211c;
    cursor: pointer;
  }
  .car-box {
    width: 1200px;
    margin: 0 auto;
    .car-title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-top: 22px;
      margin-bottom: 15px;
    }
    .margin-t {
      margin-top: 32px;
    }
    .car-item-box {
      .item-title {
        margin-left: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 12px;
      }
      .table-box {
        .image-product {
          display: flex;
          cursor: pointer;
          .title-box {
            margin-left: 15px;
          }
        }
        .image-product:hover .product-title {
          color: #e2211c;
        }
        .image-product:hover .item_no {
          color: #e2211c;
        }
        .image-box {
          width: 100px;
          height: 100px;
          background: rgba(254, 254, 254, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          img {
            width: 98px;
            height: 98px;
          }
        }
        .product-title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
        }
        .item_no {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
        .price {
          height: 100px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .number {
          height: 100px;
        }
        .total {
          height: 100px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(226, 33, 28, 1);
        }
        .do {
          height: 100px;
        }
      }
    }
    .foot-box {
      margin: 30px 0 0 0;
      width: 1200px;
      height: 60px;
      background: rgba(254, 254, 254, 1);
      line-height: 60px;
      .join-collect {
        cursor: pointer;
      }
      .join-collect:hover {
        color: #e2211c;
      }
      .del-check {
        cursor: pointer;
      }
      .del-check:hover {
        color: #e2211c;
      }
    }
    .guess-like {
      margin-top: 53px;

      .guess-title {
        border-bottom: #dddddd solid 1px;
        height: 32px;
        text-align: left;
        .guess-title-font {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(226, 33, 28, 1);
          margin-left: 24px;
        }
      }
      .guess-data {
        margin-top: 20px;
        height: 320px;
        .data-item {
          float: left;
          width: 228px;
          height: 318px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid #fff;
          margin-right: 12px;
          .img-box {
            width: 170px;
            height: 166px;
            margin: 30px auto 0 auto;
            img {
              width: 170px;
              height: 166px;
              background: rgba(242, 191, 191, 1);
            }
          }
          .title {
            margin: 10px auto 9px auto;
            width: 183px;
            height: 38px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            overflow: hidden;
            cursor: pointer;
          }
          .price {
            margin: 0 auto 0 auto;
            width: 80px;
            height: 12px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(226, 33, 28, 1);
          }
          .join-car {
            margin: 9px auto 0 auto;
            width: 92px;
          }
          .title:hover {
            color: #e2211c;
          }
        }
        .clear-m {
          margin-right: 0px;
        }
        .data-item:hover {
          border: 1px solid rgba(226, 33, 28, 1);
        }
      }
    }
    .empty {
      margin-top: 29px;
      padding-top: 90px;
      width: 1200px;
      height: 360px;
      background: rgba(254, 254, 254, 1);
      .icon-box {
        margin: 0 auto 0 auto;
        .big-car {
          font-size: 160px;
          color: #dddddd;
        }
      }
      .empty-title {
        margin-left: 40px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 600;
        color: rgba(102, 102, 102, 1);
      }
      .to-index {
        width: 150px;
        height: 46px;
        background: rgba(226, 33, 28, 1);
        border-radius: 4px;
        margin: 44px auto 0 540px;
        line-height: 46px;
        text-align: center;
        color: rgba(254, 254, 254, 1);
        cursor: pointer;
      }
    }
  }
}
</style>